// extracted by mini-css-extract-plugin
module.exports = {"onlyForMobile":"styles_onlyForMobile__3WV_h"};